import { gql } from "@apollo/client"

const IMPERSONATE_MUTATION = gql`
  mutation($input: ImpersonateInput!) {
    impersonate(input: $input)
  }
`

export { IMPERSONATE_MUTATION }
